// TODO: Inject dict instead of defining it inside the widget | Not as part of POC
export const dict = {
    AmountDisplayString: ":",
    Bets: "Bets",
    DK: "DK",
    MyBets: "My Bets",
    All: "All",
    Open: "Open",
    Settled: "Settled",
    Won: "Won",
    Lost: "Lost",
    NoData: "No Data",
    Wager: "Wager",
    ToPay: "To Pay",
    ToPayUp: "To Pay Up To",
    Paid: "Paid",
    Returned: "Returned",
    Result: "Result:",
    BetsEnded: "Bet Ended",
    HidePicks: "Hide Picks",
    ViewPicks: "View Picks",
    Picks: "Picks",
    PicksParlay: "Picks Parlay",
    ProgressiveParlay: "Pick Progressive Parlay",
    ProgressiveParlayMaxWin: "All {0} Legs Win",
    ProgressiveParlayPossibleWin: "{0} of {1} Legs Win",
    ProgressiveParlayLost: "Less Than {0} Legs Win",
    ProgressiveParlayLostReturns: "Bet Losses",
    ProgressiveParlayOutcomeHeader: "Outcome",
    ProgressiveParlayOddsHeader: "Odds",
    ProgressiveParlayPayoutHeader: "Payout",
    ProgressiverParlayVoidedSelecitonText: "One or more of the picks has voided. Your new odds are reflected below",
    ReturnWager: "RETURN WAGER",
    ProgIcon: "PROG",
    RoundRobin: "PICKS ROUND ROBIN",
    UnauthorizedBtnText: "Log In",
    UnauthorizedMessageTitle: "You're not logged in",
    UnauthorizedMessageSubtitle: "Log In to view your bet history",
    NoBetsBtnText: "View Game Lines",
    NoBetsMessageTitle: "No Bets were found",
    NoBetsMessageSubtitle: "You didn't place any bets yet",
    CashOutNewOfferMessage: "The odds changed during cash out, please try again.",
    CashOutOddsChangedMessage: "The odds changed during cash out, please try again.",
    CashOutGenericErrorMessage: "There was an error during cash out, please try again.",
    CashOut: "Cash Out",
    CashOutConfirm: "Confirm",
    CashOutSuspended: "Cash Out Suspended",
    SGP: "SGP",
    SGPExtra: "SGPx",
    CombinationPaginationText: "out of",
    Unknown: "Unknown",
    CashOutStatus: "Cashed Out",
    Cancelled: "Cancelled",
    DeadHeatReduction: "Won",
    Void: "Voided",
    BonusCashedOutMessage: "* Boost was not applied since the bet was cashed out",
    BonusDowngradedMessage: "* Boost lowered due to voided picks",
    BonusReturnedMessage: "* The reward was not applied. It will be returned for use again if the promotion is still active",
    BoostPartiallyApplied: "Boost applied on {0} picks",
    BoostPartiallyApplied1Pick: "Boost applied on {0} pick",
    BoostDetailsPicksTxt: "# of Picks",
    BoostDetailsButtonText: "Got It",
    BoostDetailsDescription: "Boost your winnings by applying the Profit Boost to any qualifying parlay. The boost percentage you’ll receive is based on eligible legs and the table below.",
    BoostDetailsBoostTxt: "Boost %",
    BoostDetailsDescriptionDowngrade: `Some of your picks have been voided, or are ineligible for parlay boost. 
    Therefore, your boost was downgraded from {0} to {1} picks boost.`,
    BoostDetailsDescriptionNotApplied: `Some of your picks have been voided, or are ineligible for parlay boost. 
    Therefore, your boost was not applied.`,
    FreeBet: "Bonus Bet",
    RiskFreeBet: "Risk Bonus Bet",
    OddsBoost: "Odds Boost",
    Boost: "Boost",
    ParlayBoost: "Parlay Boost",
    BonusIneligibleLabel: "Parlay Boost Ineligible",
    CashOutBonusDisclaimer: "If the bet is cashed out the boost will be cancelled",
    CashOutEarlyWinDisclaimer: "If the bet is cashed out the early payout will be cancelled",
    CashOutQualifyingBetDisclaimer: "If the bet is cashed out the promo will be forfeited",
    FreeBetCashOutDisclaimer: "Bonus bet stake is not included in Cash Out amount",
    DHRDisclaimer: "Dead Heat has been applied to this bet. Dead Heat occurs when two or more participants finish with the same result.",
    LearnMore: "Learn more",
    UP: "UP",
    EarlyWin: "Early Win",
    EarlyWinNotApplied: "Early win was not applied",
    EarlyWinReturned: "Early win was not applied. It was credited back to your account to use on another bet.",
    EarlyWinCashedOut: "Early win was not applied since the bet was cashed out",
    QualifyingBet: "{0}",
    QualifyingBetNotApplied: "{0}! You've received your reward.",
    QualifyingBetNotAppliedSecondChance: "You get a Second Chance and have received your reward!",
    QualifyingBetReturned: "{0} promo was not applied. It was credited back to your account to use on another bet",
    QualifyingBetCashedOut: "{0} promo was not applied since the bet was cashed out",
    Total: "T",
    Overtime: "OT",
    Runs: "R",
    Hits: "H",
    Point: "P",
    First: "1st",
    Second: "2nd",
    Third: "3rd",
    Nth: "th",
    Out: "Out",
    Top: "Top",
    Bot: "BOT",
    Bottom: "Bottom",
    And: "&",
    BaseballPlaceholder: "{0} {1}, {2}",
    BaseballPlaceholderWithotuOuts: "{0} {1}",
    DefaultPlacholder: "{0}",
    TimePlacholder: "{time} {0}",
    FirstHalf: "1ST HALF",
    BreakAfterFirstHalf: "HALFTIME",
    SecondHalf: "2ND HALF",
    RegularTimeEnd: "OVERTIME",
    AwaitingOverTime: "OVERTIME",
    FirstOvertime: "OVERTIME",
    BreakAfterFirstOvertime: "2ND OVERTIME",
    SecondOvertime: "2ND OVERTIME",
    BreakAfterSecondOvertime: "3RD OVERTIME",
    OverTimeEnd: "FULL TIME",
    AwaitingPenalties: "PENALTIES",
    PenaltyShootout: "PENALTIES",
    PenaltyShootoutEnd: "FULL TIME",
    Finished: "FULL TIME",
    FirstQuarter: "1ST QUARTER",
    BreakAfterFirstQuarter: "2ND QUARTER",
    SecondQuarter: "2ND QUARTER",
    BreakAfterSecondQuarter: "HALFTIME",
    ThirdQuarter: "3RD QUARTER",
    BreakAfterThirdQuarter: "4TH QUARTER",
    FourthQuarter: "4TH QUARTER",
    BreakAfterFourthQuarter: "OVERTIME",
    ThirdOvertime: "3RD OVERTIME",
    BreakAfterThirdOvertime: "4TH OVERTIME",
    FourthOvertime: "4TH OVERTIME",
    FirstSet: "1ST SET",
    SecondSet: "2ND SET",
    ThirdSet: "3RD SET",
    FourthSet: "4TH SET",
    FifthSet: "5TH SET",
    FirstInning: "1ST",
    SecondInning: "2ND",
    ThirdInning: "3RD",
    FourthInning: "4TH",
    FifthInning: "5TH",
    SixthInning: "6TH",
    SeventhInning: "7TH",
    EighthInning: "8TH",
    NinthInning: "9TH",
    TenthInning: "10TH",
    EleventhInning: "11TH",
    TwelfthInning: "12TH",
    ThirteenthInning: "13TH",
    FourteenthInning: "14TH",
    FifteenthInning: "15TH",
    SixteenthInning: "16TH",
    SeventeenthInning: "17TH",
    EighteenthInning: "18TH",
    NineteenthInning: "19TH",
    TwentiethInning: "20TH",
    TwentyFirstInning: "21TH",
    TwentySecondInning: "22TH",
    TwentyThirdnning: "23TH",
    TwentyFourthInning: "24TH",
    TwentyFifthInning: "25TH",
    TwentySixthInning: "26TH",
    TwentySeventhInning: "27TH",
    TwentyEightthInning: "28TH",
    TwentyNinethInning: "29TH",
    ThirtiethInning: "30TH",
    BreakAfterFirstInning: "2ND",
    BreakAfterSecondInning: "3RD",
    BreakAfterThirdInning: "4TH",
    BreakAfterFourthInning: "5TH",
    BreakAfterFifthInning: "6TH",
    BreakAfterSixthInning: "7TH",
    BreakAfterSeventhInning: "8TH",
    BreakAfterEighthInning: "9TH",
    BreakAfterNinthInning: "10TH",
    BreakAfterTenthInning: "11TH",
    BreakAfterEleventhInning: "12TH",
    BreakAfterTwelfthInning: "13TH",
    BreakAfterThirteenthInning: "14TH",
    BreakAfterFourteenthInning: "15TH",
    BreakAfterFifteenthInning: "16TH",
    BreakAfterSixteenthInning: "17TH",
    BreakAfterSeventeenthInning: "18TH",
    BreakAfterEighteenthInning: "19TH",
    BreakAfterNineteenthInning: "20TH",
    BreakAfterTwentiethInning: "21TH",
    BreakAfterTwentyFirstInning: "22TH",
    BreakAfterTwentySecondInning: "23TH",
    BreakAfterTwentyThirdnning: "24TH",
    BreakAfterTwentyFourthInning: "25TH",
    BreakAfterTwentyFifthInning: "26TH",
    BreakAfterTwentySixthInning: "27TH",
    BreakAfterTwentySeventhInning: "28TH",
    BreakAfterTwentyEightthInning: "29TH",
    BreakAfterTwentyNinethInning: "30TH",
    FirstPeriod: "1ST PERIOD",
    BreakAfterFirstPeriod: "1ST INTERMISSION",
    SecondPeriod: "2ND PERIOD",
    BreakAfterSecondPeriod: "2ND INTERMISSION",
    ThirdPeriod: "3RD PERIOD",
    FirstGame: "1ST GAME",
    BreakAfterFirstGame: "2ND GAME",
    SecondGame: "2ND GAME",
    BreakAfterSecondGame: "3RD GAME",
    ThirdGame: "3RD GAME",
    BreakAfterThirdGame: "4TH GAME",
    FourthGame: "4TH GAME",
    BreakAfterFourthGame: "5TH GAME",
    FifthGame: "5TH GAME",
    BreakAfterFifthGame: "6TH GAME",
    SixthGame: "6TH GAME",
    BreakAfterSixthGame: "7TH GAME",
    SeventhGame: "7TH GAME",
    OverTime: "OVERTIME",
    FinalScore: "Final Score",
    Replay: "Replay",
    AtBat: "At-bat",
    Pitch: "Pitch",
    Pitcher: "P",
    Batter: "B",
    EventDelimiter: "@",
    NoSweat: "No Sweat",
    SecondChance: "Second Chance",
    NewCustomer: "New Customer",
    BetAndGet: "Bet & Get",
    JackpotEligible: "Jackpot Eligible",
    OpenStatus: "Open",
    VoidStatus: "Void",
    WonStatus: "Won",
    LostStatus: "Lost",
    Pick: "Pick",
    DCrownIcon: "DraftKings Brand",
    BallSleepingIcon: "No bets available icon",
    InfoCircleIcon: "Information",
    CircleCheckMarkIcon: "Successful circular checkmark icon",
    OpenMarkIcon: "Empty Circular Icon",
    CircleXIcon: "Circular Icon with X sign",
    CircleRestrictedIcon: "Restricted Circular Icon",
    ChevronUpIcon: "Up",
    ChevronDownIcon: "Down",
    ShareIcon: "Share",
    GuaranteedPayout: "Ghost Leg Parlay",
    GhostLegActive: "If the bet is cashed out the token will be canceled.",
    GhostLegPending: "The Ghost Leg token is still eligible and pending completion.",
    GhostLegNoLongerEligible: "Your current selections no longer meet the requirements of the Ghost Leg promotion.",
    GhostLegWin: "Congrats! While one pick of your parlay lost, with the Ghost Leg promotion applied, we've paid out your winning selections!",
    GhostLegVoided: "One or more of your parlay legs have been voided. Your Ghost Leg token has been refunded and is now available for future use.",
    GhostLegCashout: "The Ghost Leg Parlay promo was not applied since the bet was cashed out.",
    GuaranteedNotNeedIt: "The Ghost Leg promotion wasn't needed as all legs settled as winners. Congrats!",
    GhostWin: "GHOST WIN",
    GhostLeg: "GHOST LEG",
    EarlyExit: "Early Exit Eligible",
    EarlyExitDescription: "This selection is eligible for Early Exit. If the bet qualifies it will be credited within 24 hours of the game ending or final leg being determined.",
    EarlyExitProtected: "Early Exit Protected",
    EarlyExitFull: "Early Exit",
    EarlyExitWin: "Early Exit Win",
    EarlyExitReturned: "This bet qualified for early exit, your bet is protected and your original stake has been returned!",
    EarlyExitApplied: "One or more legs qualified for Early Exit protection. Your new payout is reflected above!",
    EarlyExitLost: "While one or more selections may have been early exit protected, the remaining selections did not all win resulting in a loss.",
    ViewHelpCenter: "View in Help Center",
    BetBreakdownText: "{0} of this Bet is Boosted",
    BetBreakdownInfoIconLabel: "Bet breakdown information",
    BetBreakdownModalTitle: "How your boost is applied",
    BetBreakdownBoostedLine: "Boosted Amount: {0}",
    BetBreakdownStandardLine: "Unboosted Amount: {0}",
    BetBreakdownSummary: "Total Bet: {0}",
    BetBreakdownTotalPayout: "Total Payout: {0}",
    BetBreakdownPayout: "Payout: {0}",
    UpTo: "Up to",
    EarlyWinEligibleForXPicks: "Early Win Eligible for {0} picks",
    EarlyWinTooltip: "Applies to eligible moneyline selections. If your team(s) lead by the promotional amount at any point, that pick settles as a win, even if they lose the game.",
    CollapseTerms: "Collapse Terms and Conditions",
    ExpandTerms: "Expand Terms and Conditions",
    MyBetsHeader: "My Bets",
    BettingGroups: "Betting Groups",
    DKMainLogo: "Icon representing DK Logo",
    WinningCelebration: "Icon representing a Winning Celebration",
    StatusAll: "All",
    StatusOpen: "Open",
    StatusSettled: "Settled",
    StatusWon: "Won",
    StatusLost: "Lost",
    LegTrackingAriaLabel: "Leg tracking",
};
//# sourceMappingURL=dict.js.map